﻿package com.mgacreative.hotelru.feature.crm.di

import com.mgacreative.hotelru.feature.crm.ui.CrmViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getCrmFeatureModule() = module {
    viewModel { CrmViewModel(get()) }
}

